require('jquery');
require('common/noty_notifications');
require('new_camp_site_template/index');
